import React,{Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import moment from 'moment';

import ColAtm from "../../../atomic/Col/Col";
import {PageTitle} from "../../../atomic/PageHeader/PageTitle";
import PageHeaderAtm from "../../../atomic/PageHeader/PageHeader";
import {Animated} from "react-animated-css";
import Container from "@material-ui/core/Container";
import {
    getPropertyInventory,
    getQuickPricing,
    updateOrCreateInventory
} from "../../../../redux/actions/Network/Inventory/inventoryAction";
import { propertyBulkUpdateClear,getPropertyBulkUpdate } from "../../../../redux/actions/Network/Inventory/BulkUpdateAction";
import { InventoryLink, InventoryLinkClear } from "../../../../redux/actions/Network/Inventory/inventoryLinkAction";
import { getChannelSetup } from "../../../../redux/actions/Network/Channel/channelSetup.actions";
import {NETWORK, NETWORK_INVENTORY_LIST, NETWORK_COMPETITOR_DASH} from "../../../../constants/appUrls.constants";
import {addDateAndReturnRange, isDefined} from "../../../../utils";
import PriceDateRangeAdvanced from "./components/PriceDateRangeAdvanced";
import ErrorModal from "../../../organisms/Modal/ErrorModal/ErrorModal";
import {Grid} from "@material-ui/core";
import ButtonAtm from "../../../atomic/Button/Button";
import SuccessInventoryModal from "../../../organisms/Modal/SuccessModal/SuccessInventoryModal";
import SuccessModal from "../../../organisms/Modal/SuccessModal/SuccessModal";
import CompetitorAnalysisAdvanced from "./components/CompetitorAnalysisAdvanced";
import {
    getCpaClearState,
    getCpaDailyPrice,
    getPropertyCpa, setSyncCpaCompetitorClearState
} from "../../../../redux/actions/Network/Inventory/CompetitorActions";
import {getChannelCancellationList} from "../../../../redux/actions/Network/Channel/channelCancellation.actions";
import { getProperty } from "../../../../utils";
import axios from "axios";
import { USER_MENU } from "../../../../constants/api.constants";
import { getAppLang } from "../../../../utils";
import UpdateOrCreateCompetitorAnalysisModalAdvanced from "./components/UpdateOrCreateCompetitorAnalysisModalAdvanced";
import CompetitorFilterAdvanced from "./CompetitorFilterAdvanced";
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Menu from "@material-ui/core/Menu";
import MenuItem from '@material-ui/core/MenuItem';
import { propertyProducts } from "../../../../redux/actions/propertyProductsActions";
import NotAllowedPage from "../../Global/NotAllowedPage/NotAllowedPage";
import NotAllowedCpaPage from "../../Global/NotAllowedPage/NotAllowedDemoPage";
import Card from '@material-ui/core/Card';
import InventorySkeleton from "../../../molecules/InventorySkeleton/InventorySkeleton";
import LabelAtm from "../../../atomic/Label/Label";
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { AI_COMPETITOR_ANALYSIS, BEST_AVAILABLE_PRICE, LIST_PROPERTY } from "../../../../constants/api.constants";
import { getPropertyList } from "../../../../redux/actions/propertyActions";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import { withStyles } from '@material-ui/core/styles';
import Box from "@material-ui/core/Box";
import { setSyncCpaCompetitor } from "../../../../redux/actions/Network/Inventory/CompetitorActions";
import {
    getCpaGroup,
    getCpaGroupMapping,
} from "../../../../redux/actions/Network/Inventory/CpaGroupActions";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

let t=null;

// Property Select Dialog Styles
const propertyDialogStyles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(3),
        background: '#0286ff',
        color: '#fff',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: '#fff',
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.1)',
        }
    },
});

const PropertyDialogTitle = withStyles(propertyDialogStyles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Box display="flex" alignItems="center">
                <i className="fas fa-hotel" style={{ fontSize: 28, marginRight: 12 }} />
                <Typography variant="h6" style={{ fontWeight: 700, fontSize: 20, color: "#fff" }}>
                    {children}
                </Typography>
            </Box>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const PropertyDialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(3),
        backgroundColor: '#fafafa',
    },
}))(MuiDialogContent);

// Summary Card Component
const SummaryCard = ({ title, mainValue, subText, subTextColor, icon, secondaryInfo, providerText, providerLogo }) => (
    <Card style={{
        padding: '16px 20px',
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: 120,
        textAlign: "right",
        position: "relative"
    }}>
        {providerLogo && (
            <div className="cpa-summary-card-provider" 
                style={{
                    position: "absolute",
                    left: 20,
                    fontWeight: 600,
                    textAlign: "left"
            }}>
                <img alt={providerText || ''} style={{ width: "45%", height: "auto" }} src={providerLogo || ''} />
            </div>
        )}
        <div style={{ fontSize: 13, color: '#666', fontWeight: 500, marginBottom: 8 }}>
            {icon && <span style={{ marginRight: 6 }}>{icon}</span>}
            {title}
        </div>
        <div style={{ fontSize: 28, fontWeight: 700, color: '#222', marginBottom: 4 }}>
            {mainValue}
        </div>
        {subText && (
            <div style={{ fontSize: 13, fontWeight: 600, color: subTextColor || '#666' }}>
                {subText}
            </div>
        )}
        {secondaryInfo && (
            <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
                {secondaryInfo}
            </div>
        )}
    </Card>
);

class IndexAdvanced extends Component {

    constructor(props) {
        super(props);
        this.state = {
            allDays : addDateAndReturnRange(moment(new Date()).format("YYYY-MM-DD"), 14,'day'),
            startDate: moment(new Date()).format("YYYY-MM-DD"),
            endDate: moment(new Date()).add(14, 'days').format("YYYY-MM-DD"),
            channelId : this.props.match.params.id,
            isPriceUpdate : false,
            showStopSell : false,
            showMinStay : false,
            showCompetitor : false,
            showQuickPricing : false,
            propertyName : '',
            competitorTrigger: 0,
            showFilters: false,
            downloadExcel: false,
            menuAnchorEl: null,
            selectedProvider: "",
            allProviders: [],
            isLoading: false,
            competitorHotelAdded: false,
            chartKey: Date.now(),
            currency: null,
            aiAnalysisLoading: false,
            aiAnalysisResponse: null,
            showAiComment: false,
            cpaFullFilled: false,
            propertyNameCompetitor: '',
            aiAnalysisBtnAnimated: false,
            aiAnalysisBtnAnimationKey: 0,
            currentPropertyPrices: {},
            currentPropertyInfo: null,
            getBestAvailableRate : false,
            propertySelectOpen: false,
            selectedProperties: [],
            propertySelectSaving: false,
            selectedGroupId: "",
            groupFilteredHotelKeys: null,
            groupFilteredAllKeys: null,
        };
        t = props.t;
    }

    calculateSummaryData = () => {
        const { getCpa, prices } = this.props;
        const { currentPropertyPrices, currentPropertyInfo, currency, selectedProvider } = this.state;
        const lsAllDays = JSON.parse(localStorage.getItem("allDays")) || [];

        let selectedProviderLogo = null;
        if (selectedProvider) {
            Object.values(this.props.prices).some(priceObj => {
                if (Array.isArray(priceObj.all)) {
                    const found = priceObj.all.find(
                        item => item?.provider && item?.provider?.trim().toLowerCase() === selectedProvider.toLowerCase()
                    );
                    if (found && found.logo) {
                        selectedProviderLogo = found.logo;
                        return true;
                    }
                }
                return false;
            });
        }
        
        // Kendi otelimizin ortalama fiyatı
        let myTotalPrice = 0;
        let myPriceCount = 0;
        
        if (currentPropertyPrices && Object.keys(currentPropertyPrices).length > 0) {
            Object.values(currentPropertyPrices).forEach(priceObj => {
                if (priceObj && typeof priceObj.amount === 'number' && priceObj.amount > 0) {
                    myTotalPrice += priceObj.amount;
                    myPriceCount++;
                }
            });
        }
        
        const myAveragePrice = myPriceCount > 0 ? Math.round(myTotalPrice / myPriceCount) : null;

        // Rakiplerin ortalama fiyatı (provider filtresine göre)
        let competitorTotalPrice = 0;
        let competitorPriceCount = 0;
        let cheapestCompetitor = { amount: Infinity, date: null, hotelName: null };
        let expensiveCompetitor = { amount: -Infinity, date: null, hotelName: null };

        (getCpa || []).forEach(hotel => {
            lsAllDays.forEach(date => {
                const key = `${hotel.key}_${date}`;
                const priceObj = prices[key];
                
                if (!priceObj) return;

                let amount = null;
                let currencyValue = priceObj?.currency || currency;

                // Provider filtreleme
                if (selectedProvider) {
                    // Seçili provider'a göre fiyat bul
                    if (priceObj.provider && priceObj.provider.trim().toLowerCase() === selectedProvider.toLowerCase()) {
                        amount = priceObj.amount;
                    } else if (Array.isArray(priceObj.all)) {
                        const found = priceObj.all.find(
                            item => item.provider && item.provider.trim().toLowerCase() === selectedProvider.toLowerCase()
                        );
                        if (found && typeof found.amount === 'number') {
                            amount = found.amount;
                            currencyValue = found.currencyCode || currencyValue;
                        }
                    }
                } else {
                    // Filtre yoksa en düşük fiyatı al
                    amount = priceObj.amount;
                }

                // Geçerli fiyat varsa hesapla
                if (typeof amount === 'number' && amount > 0) {
                    competitorTotalPrice += amount;
                    competitorPriceCount++;

                    // En ucuz rakip kontrolü
                    if (amount < cheapestCompetitor.amount) {
                        cheapestCompetitor = {
                            amount: amount,
                            date: date,
                            hotelName: hotel?.name,
                            currency: currencyValue
                        };
                    }

                    // En pahalı rakip kontrolü
                    if (amount > expensiveCompetitor.amount) {
                        expensiveCompetitor = {
                            amount: amount,
                            date: date,
                            hotelName: hotel?.name,
                            currency: currencyValue
                        };
                    }
                }
            });
        });
        
        const competitorAveragePrice = competitorPriceCount > 0 ? Math.round(competitorTotalPrice / competitorPriceCount) : null;

        // Yüzde fark hesaplama (kendi fiyatımız vs rakip ortalaması)
        let myPriceDiffPercent = null;
        let myPriceDiffText = '';
        let myPriceDiffColor = '#666';
        
        if (myAveragePrice && competitorAveragePrice && competitorAveragePrice > 0) {
            myPriceDiffPercent = ((myAveragePrice - competitorAveragePrice) / competitorAveragePrice) * 100;
            if (Math.abs(myPriceDiffPercent) < 0.5) {
                myPriceDiffText = t('enw-cpa-same_price');
                // myPriceDiffColor = '#757575';
            } else if (myPriceDiffPercent > 0) {
                myPriceDiffText = `%${Math.abs(myPriceDiffPercent).toFixed(0)} ${t('enw-cpa-more_expensive')} ↑`;
                // myPriceDiffColor = '#d32f2f';
            } else {
                myPriceDiffText = `%${Math.abs(myPriceDiffPercent).toFixed(0)} ${t('enw-cpa-cheaper')} ↓`;
                // myPriceDiffColor = '#388e3c';
            }
        }

        // Rakip ortalaması için ters yüzde fark
        let competitorDiffText = '';
        let competitorDiffColor = '#666';
        if (myAveragePrice && competitorAveragePrice && myAveragePrice > 0) {
            const competitorDiffPercent = ((competitorAveragePrice - myAveragePrice) / myAveragePrice) * 100;
            if (Math.abs(competitorDiffPercent) < 0.5) {
                competitorDiffText = t('enw-cpa-same_price');
                // competitorDiffColor = '#757575';
            } else if (competitorDiffPercent > 0) {
                competitorDiffText = `%${Math.abs(competitorDiffPercent).toFixed(0)} ${t('enw-cpa-higher')} ↑`;
                // competitorDiffColor = '#d32f2f';
            } else {
                competitorDiffText = `%${Math.abs(competitorDiffPercent).toFixed(0)} ${t('enw-cpa-lower')} ↓`;
                // competitorDiffColor = '#388e3c';
            }
        }

        return {
            myAveragePrice,
            myPriceDiffText,
            myPriceDiffColor,
            competitorAveragePrice,
            competitorDiffText,
            competitorDiffColor,
            cheapestCompetitor: cheapestCompetitor?.amount !== Infinity ? cheapestCompetitor : null,
            expensiveCompetitor: expensiveCompetitor?.amount !== -Infinity ? expensiveCompetitor : null,
            currency: currency || 'EUR',
            selectedProvider: selectedProvider || null,
            selectedProviderLogo
        };
    };

    componentDidMount() {
        this.props.getPropertyCpa();
        this.props.propertyProducts();
        this.props.getChannelSetup({ channel_id : 1 });
        this.props.getPropertyList();
        this.props.getCpaGroup();

        const lsAllDays = JSON.parse(localStorage.getItem("allDays")) || [];

        const params = {
            params: {
                property_id: getProperty(),
            }
        }
        axios.post(USER_MENU, params, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        }).then((result) => {
            this.setState({propertyName: result.data.data.property_list[0].name + " - "});
            this.setState({propertyNameCompetitor: result.data.data.property_list[0].name});
        }).then((result) => {
            // setTimeout(() => {
            //     this.fetchBestAvailableRate()
            //         .then((bestRate) => {
            //             if (bestRate) {
            //                 const data = bestRate;
            //                 // console.log(data)
            //                 // Otel bilgisi
            //                 this.setState({
            //                     currentPropertyInfo: {
            //                         name: this.state.propertyNameCompetitor,
            //                         key: "property-" + getProperty(), 
            //                         currency: data?.currency,
            //                     }
            //                 });
            //                 const hasData = data && typeof data === "object" && !Array.isArray(data) && data.date && Object.keys(data.date).length > 0;
            //                 const pricesObj = {};
            //                 if (hasData) {
            //                     Object.entries(data.date).forEach(([date, obj]) => {
            //                         pricesObj[`${"property-"}${getProperty()}_${date}`] = {
            //                             amount: obj.rate,
            //                             currency: data?.currency,
            //                             provider: "",
            //                         };
            //                     });
            //                 }
            //                 this.setState({currentPropertyPrices: pricesObj})
            //                 this.setState({getBestAvailableRate: true})
            //                 localStorage.setItem("getBestAvailableRate", "true");
            //                 // lsAllDays.map((date) => {
            //                 //     this.props.getCpaDailyPrice(date, null, 'EUR', getProperty());
            //                 // })
            //             } else {
            //                 console.log("Best available rate not found");
            //                 localStorage.setItem("getBestAvailableRate", "false");
            //                 this.setState({getBestAvailableRate: false})
            //             }
            //         })
            // }, 100);
            
        }).catch(function (error) {
            console.log(error);
        });
    }

    // Grup değiştiğinde mapping'i çek
    handleGroupFilterChange = (e) => {
        const groupId = e.target.value;
        this.setState({ selectedGroupId: groupId });

        if (groupId === "" || groupId === "all") {
            // Filtre yok - tüm otelleri göster
            this.setState({ groupFilteredHotelKeys: null, groupFilteredAllKeys: null });
        } else {
            // Mapping'i çek
            this.props.getCpaGroupMapping({
                property_id: getProperty(),
                competitor_group_id: groupId,
            });
        }
    };
    
    // handlePropertySelectOpen = () => {
    //     // Mevcut extranetwork competitor'ları seçili olarak yükle
    //     const { getCpa, propertyList } = this.props;
    //     const existingExtranetworkIds = (getCpa || [])
    //         .filter(c => c?.competitor_property_source === "extranetwork")
    //         .map(c => parseInt(c?.key));

    //     const preSelected = (propertyList || []).filter(p => existingExtranetworkIds.includes(p?.id));

    //     this.setState({
    //         propertySelectOpen: true,
    //         selectedProperties: preSelected,
    //     });
    // };

    handlePropertySelectOpen = () => {
        this.setState({ propertySelectOpen: true });
    };

    handlePropertySelectClose = () => {
        this.setState({ propertySelectOpen: false });
    };

    handlePropertySelectChange = (event, value) => {
        this.setState({ selectedProperties: value });
    };

    handlePropertySelectSave = () => {
        const { selectedProperties } = this.state;
        const { getCpa } = this.props;
        const lsAllDays = JSON.parse(localStorage.getItem("allDays"));

        // Mevcut tripadvisor competitor'ları koru
        const existingNonExtranetwork = (getCpa || []).filter(
            c => c.competitor_property_source !== "extranetwork"
        );

        // Seçilen property'leri extranetwork formatına dönüştür
        const extranetworkCompetitors = selectedProperties.map(p => ({
            id: p.id,
            property_id: parseInt(getProperty()),
            name: p.name,
            key: String(p.id),
            competitor_property_source: "extranetwork",
        }));

        // Hepsini birleştir
        const allCompetitors = [...existingNonExtranetwork, ...extranetworkCompetitors];

        this.setState({ propertySelectSaving: true });

        // this.props.setSyncCpaCompetitorClearState();

        // // Dispatch sync
        // const { dispatch } = this.props;
        // if (dispatch) {
        //     dispatch(setSyncCpaCompetitor(allCompetitors));
        // } else {
        //     // connect ile bağlıysa doğrudan props'tan çağır
        //     // setSyncCpaCompetitor mapDispatchToProps'ta olmalı
        // }

        // this.props.setSyncCpaCompetitor(allCompetitors);
    }

    getPropertyInvertory = () => {

        const {channelId, startDate, endDate} = this.state

        if ( channelId !== undefined && channelId !== '' && !isNaN(channelId) )
        {
            this.props.getPropertyInventory( startDate, endDate, channelId );

        }else{
            this.props.history.replace(NETWORK);
        }
    }

    getPropertyInvertoryDate = (startDate, endDate) => {

        const {channelId} = this.state

        if ( channelId !== undefined && channelId !== '' )
        {
            this.props.getPropertyInventory( startDate, endDate, channelId );
        }
    }

    nextDate = (startDate, endDate) => {
        this.getPropertyInvertoryDate(startDate,endDate);
    }

    previousDate = (startDate, endDate) => {
        this.getPropertyInvertoryDate(startDate,endDate);
    }


    showMessage = () => {
        const {channelId} = this.state;
        if( this.props.inventoryUpdate === 200 ){
            return <SuccessInventoryModal status={true}
                                          message={t('enw-notification_success')}
                                          channelId={channelId}
            />
        }

        if( this.props.error !== {}  &&
            this.props.error?.response
        ){
            let message = this.props.error.response.data.message
            return  <ErrorModal status={true} message={message}/>
        }
    }

    showInventoryLinkMessage = () => {

        const linkData = isDefined(this.props.inventoryLinkData) && isDefined(this.props.inventoryLinkData.inventoryLink) && this.props.inventoryLinkData.inventoryLink
        const error = isDefined(this.props.inventoryLinkData) && isDefined(this.props.inventoryLinkData.error) && this.props.inventoryLinkData.error

        if( linkData.status === 200 ){
            return <SuccessModal status={true}
                                 message={t('enw-notification_success')}
            />
        }

        if( error !== {}  &&
            error?.response
        ){
            let message = error.response.data.message
            return  <ErrorModal status={true} message={message}/>
        }
    }

    showStopSell = () => {
        const { showMinStay, showCompetitor, showQuickPricing } = this.state;

        this.setState({showStopSell: !this.state.showStopSell})

        if(showMinStay || showCompetitor || showQuickPricing) {
            this.setState({showQuickPricing: false, showMinStay: false, showCompetitor: false, showStopSell: true})
        }
    }
    showMinStay = () => {
       this.setState({showMinStay: !this.state.showMinStay})
        const { showStopSell, showCompetitor, showQuickPricing } = this.state;

        if(showStopSell || showCompetitor || showQuickPricing) {
            this.setState({showMinStay: true, showQuickPricing: false, showCompetitor: false, showStopSell: false})
        }
    }

    showCompetitor = () => {
        const { showStopSell, showMinStay, showCompetitor, showQuickPricing, downloadExcel } = this.state;

        this.setState({ chartKey: Date.now() });
        this.setState({showCompetitor: !this.state.showCompetitor});

        this.setState({ isLoading: true, showCompetitor: !this.state.showCompetitor });
        this.setState(prevState => ({
            competitorTrigger: prevState.competitorTrigger + 1
        }));

         if (this.state.showCompetitor === false) {
            this.fetchBestAvailableRate()
                .then((bestRate) => {
                    if (bestRate) {
                        const data = bestRate;
                        this.setState({
                            currentPropertyInfo: {
                                name: this.state.propertyNameCompetitor,
                                key: "property-" + getProperty(), 
                                currency: data?.currency,
                            }
                        });
                        const hasData = data && typeof data === "object" && !Array.isArray(data) && data.date && Object.keys(data.date).length > 0;
                        const pricesObj = {};
                        if (hasData) {
                            Object.entries(data.date).forEach(([date, obj]) => {
                                pricesObj[`${"property-"}${getProperty()}_${date}`] = {
                                    amount: obj.rate,
                                    currency: data?.currency,
                                    provider: "",
                                };
                            });
                        }
                        this.setState({
                            currentPropertyPrices: pricesObj,
                            getBestAvailableRate: true
                        });
                        localStorage.setItem("getBestAvailableRate", "true");
                    }
                })
                .catch((error) => {
                    console.log("Best available rate error:", error);
                });
        }

        if (this.state.showCompetitor === false) {
            this.props.setSyncCpaCompetitorClearState();
            this.props.getCpaClearState();
            window.stop();
        }
        
        this.setState(prevState => ({
            competitorTrigger: prevState.competitorTrigger + 1
        }));

        if(showStopSell || showMinStay || showQuickPricing) {
            this.setState({showQuickPricing: false, showMinStay: false, showStopSell: false, showCompetitor: true})
        }

        if (showCompetitor === false) {
            this.props.setSyncCpaCompetitorClearState();
            this.props.getCpaClearState();

            window.stop();
        }
    }

    showFilters = () => {
        if (this.state.competitorTrigger !== 0) {
            this.setState({showFilters: true})
        }
    }

     downloadExcelFile = () => {
        this.setState({downloadExcel: true})
        setTimeout(() => {
            this.setState({downloadExcel: false})
        }, 100);
    }

    handleMenuOpen = (event) => {
        this.setState({ menuAnchorEl: event.currentTarget });
    };

    handleMenuClose = () => {
        this.setState({ menuAnchorEl: null });
    };

    handleProviderChange = (e) => {
        this.setState({ selectedProvider: e.target.value });
    };
    handleProvidersChange = (providers) => {
        this.setState({ allProviders: providers });
    };
    handleCompetitorHotelAdded = () => {
        this.setState({ competitorHotelAdded: true });
    }

    getProviderLogos = () => {
        const { prices } = this.props;
        const providerLogos = {};
        Object.values(prices).forEach(priceObj => {
            if (Array.isArray(priceObj?.all)) {
                priceObj.all.forEach(item => {
                    if (item.provider && item.logo) {
                        providerLogos[item.provider.trim().toLowerCase()] = item.logo;
                    }
                });
            }
        });
        return providerLogos;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.isLoading && this.props.prices && Object.keys(this.props.prices).length > 0 && this.props.prices !== prevProps.prices) {
            this.setState({ isLoading: false });
        } else if(this.state.isLoading && this.props.prices && this.props.prices === prevProps.prices) {
            setTimeout(() => {
                this.setState({ isLoading: false });
            }, 1000);
        }

        if (this.props.channelInformationData !== prevProps.channelInformationData) {
            if (this.props.channelInformationData && !Array.isArray(this.props.channelInformationData) && typeof this.props.channelInformationData === 'object' &&
                this.props.channelInformationData.currency &&
                this.props.channelInformationData.currency !== this.state.currency
            ) {
                this.setState({ currency: this.props.channelInformationData.currency });
            } else if (Array.isArray(this.props.channelInformationData) && this.state.currency !== 'USD') {
                this.setState({ currency: 'USD' });
            }
        }

        if (prevState.currentPropertyPrices !== this.state.currentPropertyPrices) {
            this.forceUpdate();
        }

        if (
            prevProps.cpaReducer?.fetching === true &&
            this.props.cpaReducer?.fetching === false &&
            !this.state.propertySelectOpen
        ) {
            const cpa = this.props.getCpa;
            // getCpa boş veya undefined ise -> modal aç
            if (!cpa || cpa.length === 0) {
                this.setState({ propertySelectOpen: true });
            } else {
                // getCpa dolu ama extranetwork yoksa -> modal aç
                const hasExtranetwork = cpa.some(
                    item => item?.competitor_property_source === 'extranetwork'
                );
                if (!hasExtranetwork) {
                    this.setState({ propertySelectOpen: true });
                }
            }
        }

        // const propertyProductCompetitor = !this.props.propertyProductsReducer.fetching &&
        //     isDefined(this.props.propertyProductsReducer) &&
        //     isDefined(this.props.propertyProductsReducer.get_products) &&
        //     Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "competitor-analysis" === item.route)

        // if (propertyProductCompetitor.length > 0) {
        //     if (!propertyProductCompetitor[0].property_has_product) {
        //         this.props.history.replace(NETWORK);
        //     }
        // }

        if (
            prevProps.cpaReducer?.fetching === true &&
            this.props.cpaReducer?.fetching === false &&
            (!this.props.getCpa || this.props.getCpa.length === 0) &&
            !this.state.propertySelectOpen
        ) {
            this.setState({ propertySelectOpen: true });
        }

        // cpaReducer'da error varsa ve getCpa boşsa da modal aç
        if (
            !prevProps.cpaReducer?.error &&
            this.props.cpaReducer?.error &&
            (!this.props.getCpa || this.props.getCpa.length === 0) &&
            !this.state.propertySelectOpen
        ) {
            this.setState({ propertySelectOpen: true });
        }

        if (this.props.cpaReducer?.syncCompetitor?.status === 200 && prevProps.cpaReducer?.syncCompetitor?.status !== 200) {
            if (this.state.propertySelectSaving) {
                this.setState({ propertySelectSaving: false, propertySelectOpen: false });
                this.props.getPropertyCpa();
            }
        }

        const loadingValues = Object.values(this.props?.cpaReducer?.loading || {});
        const allDone = loadingValues.length > 0 && loadingValues.every(v => v === false);

       if (!prevState.cpaFullFilled && allDone) {
            this.setState({
                cpaFullFilled: true,
                aiAnalysisBtnAnimated: true,
                aiAnalysisBtnAnimationKey: Date.now()
            }, () => {
                setTimeout(() => {
                    this.setState({ aiAnalysisBtnAnimated: false });
                }, 1200);
            });
        } else if (prevState.cpaFullFilled && !allDone) {
            this.setState({ cpaFullFilled: false });
        }

        if (
            this.props.cpaGroupMapping !== prevProps.cpaGroupMapping &&
            this.state.selectedGroupId &&
            this.state.selectedGroupId !== "" &&
            this.state.selectedGroupId !== "all"
        ) {
            const mapping = this.props.cpaGroupMapping;
            if (Array.isArray(mapping)) {
                // Tüm key'leri source bilgisiyle birlikte sakla
                const allKeys = mapping.map(m => ({
                    source: m?.competitor_property_source,
                    key: String(m?.competitor_property_key),
                }));
                // Sadece key string'leri
                const keys = mapping.map(m => String(m?.competitor_property_key));
                this.setState({ 
                    groupFilteredHotelKeys: keys,
                    groupFilteredAllKeys: allKeys,
                });
            }
        }

    }

    getFilteredPropertyList = () => {
        const { getCpa, propertyList } = this.props;
        if (!getCpa || !propertyList) return [];

        // getCpa'dan competitor_property_source extranetwork olanların key'lerini al
        const extranetworkKeys = (getCpa || [])
            .filter(c => c?.competitor_property_source === "extranetwork")
            .map(c => parseInt(c?.key));

        // propertyList'ten sadece bu id'lere sahip olanları filtrele
        // Kendi otelimizi hariç tut
        const currentId = parseInt(getProperty());
        return (propertyList || []).filter(
            p => extranetworkKeys.includes(p?.id) && p?.id !== currentId
        );
    };

    // Property Payload
    getPropertyPayload = (bestAvailableRate, propertyName) => {
        const prices = {};
        if (bestAvailableRate?.date) {
            Object.entries(bestAvailableRate.date).forEach(([date, obj]) => {
                prices[date] = obj.rate;
            });
        }
        return {
            name: this.state?.propertyNameCompetitor ?? "",
            currency: bestAvailableRate?.currency ?? "EUR",
            prices
        };
    };

    // Competitor Payload
    getCompetitorPayload = (getCpa, prices, lsAllDays) => {
        return (getCpa || []).map(hotel => {
            const hotelPrices = {};
            lsAllDays.forEach(date => {
                const key = `${hotel.key}_${date}`;
                const priceObj = prices[key];
                if (priceObj?.amount !== null && priceObj?.amount !== undefined) {
                    hotelPrices[date] = priceObj.amount;
                }
            });
            return {
                name: hotel?.name,
                currency: hotel?.currency ?? "EUR",
                prices: hotelPrices
            };
        });
    };

    // Best Available Rate
    fetchBestAvailableRate = () => {
        const lsAllDays = JSON.parse(localStorage.getItem("allDays"));
        if (!lsAllDays || lsAllDays.length === 0) {
            return Promise.reject("No days found in localStorage");
        }

        const requests = lsAllDays.map(date => {
            const params = {
                params: {
                    type: "date",
                    property_id: getProperty(),
                    date: date,
                    currency: "EUR"
                }
            };
            return axios.post(BEST_AVAILABLE_PRICE, params, {
                headers: {
                    "Accept": "application/json",
                    authToken: localStorage.getItem('auth'),
                    "Content-Type": "application/json",
                    "language": getAppLang(),
                }
            }).then(result => result.data.data).catch(() => null);
        });

        return Promise.all(requests).then(results => {
            this.setState({ getBestAvailableRate: true });
            let mergedCurrency = "EUR";
            const mergedDates = {};
            results.forEach(data => {
                if (data && data.date && typeof data.date === "object") {
                    if (data.currency) mergedCurrency = data.currency;
                    Object.entries(data.date).forEach(([dateKey, obj]) => {
                        mergedDates[dateKey] = obj;
                    });
                }
            });
            return { currency: mergedCurrency, date: mergedDates };
        }).catch((error) => {
            console.log(error);
            localStorage.setItem("getBestAvailableRate", "false");
            this.setState({ getBestAvailableRate: false });
            throw error;
        });
    };

    // AI Competitor Analysis
    postAiCompetitorAnalysis = ({ property_id, language, property, competitor }) => {
        const payload = {
            params: {
                property_id,
                language,
                property,
                competitor
            }
        };

        return axios.post(AI_COMPETITOR_ANALYSIS, payload, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                authToken: localStorage.getItem('auth'),
                "language": getAppLang(),
            }
        });
    };

    handleAiAnalysisClick = () => {
        if (this.state.aiAnalysisLoading) return;
        this.setState({ aiAnalysisLoading: true });
        
        const lsSelectedDays = JSON.parse(localStorage.getItem("allDays"));

        this.fetchBestAvailableRate()
            .then((bestRate) => {
                if (bestRate) {
                    const propertyPayload = this.getPropertyPayload(bestRate, this.state.propertyName);
                    const competitorPayload = this.getCompetitorPayload(
                        this.props.getCpa,
                        this.props.prices,
                        lsSelectedDays
                    );

                    const hasValidPrices = competitorPayload.some(hotel => Object.keys(hotel.prices).length > 0);

                    if (hasValidPrices) {
                        return this.postAiCompetitorAnalysis({
                            property_id: getProperty(),
                            language: getAppLang(),
                            property: propertyPayload,
                            competitor: competitorPayload
                        });
                    }
                } else {
                    console.log("Best available rate not found");
                }
            })
            .then(response => {
                this.setState({
                    aiAnalysisResponse: response?.data,
                    showAiComment: !!response?.data?.data?.comment
                });
            })
            .catch(error => {
                console.error("AI analysis error:", error);
            })
            .finally(() => {
                this.setState({ aiAnalysisLoading: false });
            });
    };

    render() {
        const {t, inventory, channelInformationData, channelInformationFetching, getCpa, cpaReducer, propertyProductsReducer, propertyList, cpaGroup, cpaGroupFetching, cpaGroupMappingFetching} = this.props;
        const {allDays, startDate, endDate, showCompetitor, showFilters, downloadExcel, competitorTrigger, allProviders, selectedGroupId, groupFilteredHotelKeys} = this.state;
        const screenWidth = window.innerWidth;

        const propertyProductCompetitor = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "competitor-analysis" === item.route)
            // if (propertyProductCompetitor[0]) {
            //     propertyProductCompetitor[0].status = 3;
            //     propertyProductCompetitor[0].property_has_product = false;
            // } // Demo sonu test

        const summaryData = this.calculateSummaryData();
        const currentId = parseInt(getProperty());
        const availableProperties = (propertyList || []).filter(p => p != null);
        const filteredPropertyList = this.getFilteredPropertyList();
        const filteredGetCpa = groupFilteredHotelKeys !== null
            ? (getCpa || []).filter(c => groupFilteredHotelKeys.includes(String(c.key)))
            : getCpa;

        return(
            <>
                <PageTitle title={ t('enw-input-competitor') } />
                <PageHeaderAtm 
                    backButton={NETWORK_COMPETITOR_DASH}
                    exitText={ t('btn-dashboard') }
                    text={ t('enw-input-competitor') }
                />
                {
                    isDefined(propertyProductCompetitor[0]) && !propertyProductCompetitor[0].property_has_product && propertyProductCompetitor[0].status === 1 ?
                        <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                            <Grid item xs={12} lg={6} className="no-buy-product no-buy-product-web">
                                <Card className="p-24">
                                    <NotAllowedCpaPage productId={propertyProductCompetitor[0]?.id} isTrialEnd={false} />
                                </Card>
                            </Grid>
                        </Animated>
                    : 
                    isDefined(propertyProductCompetitor[0]) && !propertyProductCompetitor[0].property_has_product && propertyProductCompetitor[0].status === 3 ?
                        <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                            <Grid item xs={12} lg={6} className="no-buy-product no-buy-product-web">
                                <Card className="p-24">
                                    <NotAllowedCpaPage
                                        trialEndTitle = {t('enw-trial_end-product_title')}
                                        trialEndDesc = {t('enw-trial_end-product_desc')}
                                        trialEndBtnText = {t('enw-not-product_btn')}
                                        isTrialEnd={true}
                                    />
                                </Card>
                            </Grid>
                        </Animated>
                    :
                    this.props.propertyProductsReducer.fetching || cpaReducer?.fetching ?
                        <>
                            <style>{`
                                @media (min-width: 768px) {
                                    .skeleton-inventory-box {
                                        width: 87.5% !important;
                                        margin: 0 auto !important;
                                        margin-top:32px !important;
                                        height:auto!important
                                    }
                                }
                            `}</style>
                            <InventorySkeleton/>
                        </>
                    :
                    !cpaReducer?.fetching && cpaReducer?.getCpa?.length > 0 ?
                    <>
                    {this.state.aiAnalysisResponse?.data?.comment && this.state.showAiComment && (
                        <Animated animationIn="bounceInUp" animationInDuration={1000} isVisible={true}
                            style={{position: "fixed", bottom: "1px", right: "1px", width: "100%", zIndex: "999", justifyContent: "center", display: "flex" }} 
                        >
                            <div className="competitor-ai-comment-box">
                                {/* <i className="fas fa-robot" style={{ color: "#d71f26", fontSize: 32, marginRight: 8 }} /> */}
                                <svg xmlns="http://www.w3.org/2000/svg" style={{color: "#d71f26"}} className="competitor-ai-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path><path d="M20 3v4"></path><path d="M22 5h-4"></path><path d="M4 17v2"></path><path d="M5 18H3"></path></svg>
                                <div style={{ flex: 1, fontSize: 16, color: "#222", maxHeight: "500px", overflow: "scroll" }}>
                                    {this.state.aiAnalysisResponse.data.comment} <span style={{fontWeight: 600}}>{this.state.aiAnalysisResponse?.data?.recommendation}</span>
                                </div>
                                <IconButton
                                    size="small"
                                    onClick={() => this.setState({ showAiComment: false })}
                                    style={{ marginLeft: 8 }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </Animated>
                    )}
                    <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                        <Container maxWidth="xl">
                            <div className="container-width m-inventory-container">
                                <Grid container className="mb-16 cpa-button-container" spacing={screenWidth > 768 ? 3 : 0} alignItems="center">
                                    <Grid item xs={12} md={4} className="cpa-top-buttons-left" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                                            <ButtonAtm 
                                                className="inventory-action-btn bg-green inventory-filter-box btn-start-cpa"
                                                buttontext={this.state.isLoading ? t('enw-payment-manual_payment-loading-message') : t('btn-start-competitor_analysis') }
                                                fullwidth={screenWidth > 768 ? false : true}
                                                onClick={this.showCompetitor}
                                                disabled={this.state.isLoading || getCpa?.length < 1}
                                                startIcon={this.state.isLoading ? 
                                                <i style={{fontSize: "12px", marginTop: "2px"}} className="fas fa-spinner-third fa-spin"></i> 
                                                : <i style={{fontSize: "12px", marginTop: "2px"}} className="fas fa-play" />}
                                            />

                                            <ButtonAtm
                                                className="inventory-action-btn bg-dark-blue inventory-filter-box"
                                                buttontext={t('enw-cpa_add-hotel')}
                                                fullwidth={screenWidth > 768 ? false : true}
                                                onClick={this.handlePropertySelectOpen}
                                                startIcon={<i style={{fontSize: "12px", marginTop: "2px"}} className="fas fa-building" />}
                                            />

                                            {/* Grup Filtre SelectBox */}
                                            {/* <FormControl
                                                variant="outlined"
                                                size="small"
                                                style={{
                                                    minWidth: 180,
                                                    backgroundColor: '#fff',
                                                    borderRadius: 8,
                                                }}
                                            >
                                                <InputLabel style={{ fontWeight: 500 }}>
                                                    {'Grup Filtrele'}
                                                </InputLabel>
                                                <Select
                                                    value={selectedGroupId}
                                                    onChange={this.handleGroupFilterChange}
                                                    label={'Grup Filtrele'}
                                                    style={{ borderRadius: 8 }}
                                                    disabled={cpaGroupFetching}
                                                    startAdornment={
                                                        <i className="fas fa-layer-group" style={{ color: '#667eea', marginRight: 8, marginLeft: 4, fontSize: 13 }} />
                                                    }
                                                >
                                                    <MenuItem value="">
                                                        <em>{'Tüm Oteller'}</em>
                                                    </MenuItem>
                                                    {cpaGroup && cpaGroup.map((group) => (
                                                        <MenuItem key={group.id} value={group.id}>
                                                            <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                                                                <i className="fas fa-folder" style={{ fontSize: 12, color: '#f57c00' }} />
                                                                {group.name}
                                                            </Box>
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl> */}

                                            <ButtonGroup
                                                variant="contained"
                                                className="cpa-filter-btn"
                                                style={{
                                                    borderRadius: 8,
                                                    boxShadow: "none"
                                                }}
                                            >
                                                <Button
                                                    style={{
                                                        color: "#fff",
                                                        minWidth: 120,
                                                        fontWeight: 700,
                                                        textTransform: "none",
                                                        borderRadius: "8px"
                                                    }}
                                                    className="bg-dark-orange"
                                                    onClick={this.handleMenuOpen}
                                                    disabled={!this.state.competitorHotelAdded && competitorTrigger === 0}
                                                    startIcon={<i style={{fontSize: "12px", marginTop: "2px"}} className="fas fa-filter" />}
                                                    fullwidth={screenWidth > 768 ? false : true}
                                                >
                                                    {this.state.selectedProvider
                                                        ? this.state.selectedProvider.charAt(0).toUpperCase() + this.state.selectedProvider.slice(1)
                                                        : t('enw-input-filter_provider-title')}
                                                    <ArrowDropDownIcon />
                                                </Button>

                                                <Menu
                                                    id="filter-menu"
                                                    anchorEl={this.state.menuAnchorEl}
                                                    keepMounted
                                                    open={Boolean(this.state.menuAnchorEl)}
                                                    onClose={this.handleMenuClose}
                                                >
                                                    <CompetitorFilterAdvanced
                                                        providers={allProviders}
                                                        selectedProvider={this.state.selectedProvider}
                                                        onChange={this.handleProviderChange}
                                                        onClose={this.handleMenuClose}
                                                        providerLogos={this.getProviderLogos()}
                                                    />
                                                </Menu>
                                            </ButtonGroup>
                                    </Grid>

                                    <Grid item xs={12} md={8}>
                                        <PriceDateRangeAdvanced
                                            allDays={allDays}
                                            startDate={startDate}
                                            endDate={endDate}
                                            previousDate={this.previousDate}
                                            nextDate={this.nextDate}
                                            getPropertyInvertoryDate={this.getPropertyInvertoryDate}
                                            fetching={this.props.fetching}
                                            getCpa={getCpa}
                                            showCompetitor={showCompetitor}
                                            getCpaDailyPrice={this.props.getCpaDailyPrice}
                                            getCpaClearState={this.props.getCpaClearState}
                                            trigger={this.state.competitorTrigger}
                                            currency={this.state.currency}
                                            onDateRangeChange={() => {
                                                if (this.state.showCompetitor) {
                                                    this.setState(prevState => ({
                                                        competitorTrigger: prevState.competitorTrigger + 1
                                                    }));
                                                }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                {
                                    <>
                                        <CompetitorAnalysisAdvanced
                                            key={this.state.chartKey}
                                            trigger={this.state.competitorTrigger}
                                            allDays={this.state.allDays}
                                            showFilters={showFilters}
                                            downloadExcel={downloadExcel}
                                            selectedProvider={this.state.selectedProvider}
                                            onProvidersChange={this.handleProvidersChange}
                                            currency={this.state.currency}
                                            propertyName={this.state.propertyNameCompetitor}
                                            getBestAvailableRate={err => this.setState({ getBestAvailableRate: err })}
                                            currentPropertyInfo={this.state.currentPropertyInfo}
                                            currentPropertyPrices={this.state.currentPropertyPrices}
                                            propertyList={this.props.propertyList}
                                            groupFilteredHotelKeys={groupFilteredHotelKeys}
                                            groupFilteredAllKeys={this.state.groupFilteredAllKeys}
                                            cpaGroup={cpaGroup}
                                            cpaGroupFetching={cpaGroupFetching}
                                            cpaGroupMappingFetching={this.props.cpaGroupMappingFetching}
                                            selectedGroupId={selectedGroupId}
                                            onGroupFilterChange={this.handleGroupFilterChange}
                                        />
                                    </>
                                }
                                {
                                    this.props.propertyListFetching &&
                                        <CircularProgress size={36} className="list-fetching-spinner" style={{ color: '#d71f26' }} />
                                }

                            </div>
                        </Container>

                        <UpdateOrCreateCompetitorAnalysisModalAdvanced
                            allDays={localStorage.getItem("allDays")}
                            getCpa={getCpa}
                            currency={this.state.currency}
                            propertyProducts={this.props.propertyProductsReducer}
                            propertyList={this.props.propertyList}
                            propertyListFetching={this.props.propertyListFetching}
                            isOpen={this.state.propertySelectOpen}
                            onClose={this.handlePropertySelectClose}
                            onSave={this.handlePropertySelectSave}
                            onGroupChange={(groupId) => {
                                const syntheticEvent = { target: { value: groupId } };
                                this.handleGroupFilterChange(syntheticEvent);
                            }}
                        />
                       
                        <style>{`
                            .fa-spin {
                                -webkit-animation: fa-spin 2s linear infinite!important;
                                animation: fa-spin 1s linear infinite!important;
                            }
                            .MuiPopover-paper {
                                width:310px
                            }
                            @media (max-width: 768px) {
                                .MuiPopover-paper {
                                    width:87vw;
                                }
                                .container-width {
                                    padding:20px 0 20px !important;
                                }
                                .cpa-filter-btn {
                                    width:100%!important;
                                }
                            }
                            .inventory-action-btn {
                                max-height: 45px;
                            }
                            .MuiButtonGroup-groupedContainedHorizontal:not(:last-child).Mui-disabled {
                                border:0px !important;
                            }
                            .cpa-top-buttons-left button {
                                padding: 10px 25px !important;
                            }
                            @media (min-width: 768px) {
                                .inventory-price-day, .inventory-price {
                                    width:11.5% !important;
                                }
                                .btn-start-cpa {
                                    width:125px !important;
                                }
                                .list-fetching-spinner {
                                    top: 125% !important;
                                    left: 50% !important;
                                }
                            }
                            @media (max-width: 768px) {
                                .list-fetching-spinner {
                                    left: 50% !important;
                                    top: 100% !important;
                                }
                            }
                            .modal-loading-spinner {
                                top:55% !important;
                            }
                        `}</style>
                    </Animated>
                    
                    </>
                    :
                    <>
                        <Grid container spacing={3} className="mt-60 web-dashboard centered-position">
                            <Container maxWidth="xl">
                                <div className="container-width">
                                    <ColAtm xs={12} className="photoButtonsRow one-page-content">
                                        <ColAtm>
                                            <div className="m-auto first-create-room">
                                                <UpdateOrCreateCompetitorAnalysisModalAdvanced
                                                    allDays={localStorage.getItem("allDays")}
                                                    getCpa={getCpa}
                                                    currency={this.state.currency}
                                                    propertyProducts={this.props.propertyProductsReducer}
                                                    propertyList={this.props.propertyList}
                                                    propertyListFetching={this.props.propertyListFetching}
                                                    isOpen={this.state.propertySelectOpen}
                                                    onClose={this.handlePropertySelectClose}
                                                    onSave={this.handlePropertySelectSave}
                                                />
                                            </div>
                                        </ColAtm>
                                        <LabelAtm labelClass="one-page-title"
                                            text={t('btn-create_cpa-first-title')} />
                                        <LabelAtm labelClass="one-page-subtitle p-0-100"
                                            text={t('btn-create_cpa-first-desc')} />
                                    </ColAtm>
                                </div>
                            </Container>
                        </Grid>
                        <style>{`
                            .first-create-room .cpa-new-property-btn {
                                padding: 72px 82px !important;
                                margin-bottom:1rem !important;
                            }
                            .filter-action-button span i {
                                margin-right:0px!important;
                            }
                            .web-dashboard {
                                min-height: calc(100vh - 145px);
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                margin-top: 0px !important;
                                align-items: center;
                            }
                        `}</style>
                    </>
                }
                {this.showMessage()}
                {this.showInventoryLinkMessage()}
            </>
            
        )
    }
}


const mapStateToProps = (props) => {
    return {
        fetching        : props.inventoryReducer.fetching,
        error           : props.inventoryReducer.error,
        inventory       : props.inventoryReducer.inventory,
        inventoryUpdate : props.inventoryReducer.inventoryUpdate ?. status,
        inventoryUpdateError : props.inventoryReducer.inventoryUpdate ?. error,
        channelInformationFetching : props.channelSetupReducers.fetching,
        channelInformationData : props.channelSetupReducers.channelInformationData,
        channelAvailability : props.channelSetupReducers.channelInformationAvaility,
        channelSetupData : props.channelSetupReducers.channelSetupData.data,
        inventoryLinkData: props.inventoryLinkReducer,
        getCpa: props.cpaReducer.getCpa,
        cpaReducer: props.cpaReducer,
        quickPricingData: props.quickPricingReducer.quickPricing,
        getQuickPricingData: props.quickPricingReducer,
        propertyProductsReducer : props.propertyProductsReducer,
        prices: props.cpaReducer.prices,
        cpaPromotionAvailable: props.cpaReducer.cpaPromotionAvailable,
        cpaPromotionAvailableFetching: props.cpaReducer.cpaPromotionAvailableFetching,
        cpaPromotionAvailableError: props.cpaReducer.cpaPromotionAvailableError,
        propertyList: props.propertyReducer.property_list,
        propertyListFetching: props.propertyReducer.fetching,
        // Group
        cpaGroup: props.cpaGroupReducer.cpaGroup,
        cpaGroupFetching: props.cpaGroupReducer.cpaGroupFetching,
        cpaGroupMapping: props.cpaGroupReducer.cpaGroupMapping,
        cpaGroupMappingFetching: props.cpaGroupReducer.cpaGroupMappingFetching,
    }
};

const mapDispatchToProps ={
    getPropertyInventory,
    getChannelSetup,
    updateOrCreateInventory,
    getPropertyBulkUpdate,
    InventoryLink,
    InventoryLinkClear,
    propertyBulkUpdateClear,
    getPropertyCpa,
    getCpaDailyPrice,
    getCpaClearState,
    setSyncCpaCompetitorClearState,
    getChannelCancellationList,
    getQuickPricing,
    propertyProducts,
    getPropertyList,
    setSyncCpaCompetitor,
    getCpaGroup,
    getCpaGroupMapping,
};
export default compose(withTranslation('common')) (connect(mapStateToProps, mapDispatchToProps )(IndexAdvanced));
